import { createAsyncThunk } from '@reduxjs/toolkit';

import { entitiesActions } from '../slices/entitiesSlice';
import type { RootState } from '../store';

import { groupsService } from './_deps';

export const deleteGroup = createAsyncThunk<string, string, { state: RootState }>(
  'groups/delete',
  async (groupId, thunkApi) => {
    const { dispatch, getState } = thunkApi;

    try {
      await groupsService.deleteGroup({ groupId });
      dispatch(entitiesActions.removeGroup(groupId));
      return groupId;
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Не удалось удалить группу';
      throw error;
    }
  },
);
